/* src/modules/create_tutor/selectors.js */

import { createSelector } from 'reselect';
import { find, forEach, map } from 'lodash';

export const getOrganization = createSelector(
  state => state.auth.data.user.organizations,
  state => state.auth.selectedOrganization,
  (organizations, selected) => {
    const org = find(organizations, o => o._id === selected);
    if (!org) return null;
    return org.name;
  }
);

export const getUniversity = createSelector(
  state => state.auth.data.user.universities,
  state => state.auth.selectedUniversity,
  (universities, selected) => {
    const uni = find(universities, u => u._id === selected);
    if (!uni) return null;
    return uni.name;
  }
);

export const getTutors = createSelector(
  state => state.createTutor.data,
  tutors => map(tutors, ({ user, courses }) => ({
    name: `${user.first} ${user.last}`,
    email: user.email,
    courses: courses.reduce((acc, { course }) => {
      const courseString = `${course.subject} ${course.number}`;
      if (!acc) return courseString;
      return `${acc}, ${courseString}`;
    }, ''),
  }))
);

export const getSearchResult = createSelector(
  state => state.courses.search.data,
  courses => {
    const notFound = [];
    const found = [];
    const c = [];
    forEach(courses, ({ _id, result }) => {
      if (!result) {
        notFound.push(_id.split(';')[0]);
      } else {
        found.push(`${result.subject} ${result.number}`);
        c.push({ _course: result._id });
      }
    });
    return {
      found: found.reduce((acc, x) => (acc ? `${acc}, ${x}` : x), ''),
      notFound: notFound.reduce((acc, x) => (acc ? `${acc}, ${x}` : x), ''),
      courses: c,
    };
  }
);



// WEBPACK FOOTER //
// ./src/modules/create_tutor/selectors.js